import styled from 'styled-components';

const ButtonStyled = styled.button`
  background: var(--primary);
  width: 100%;
  padding: 14px 0;
  border: none;
  color: var(--white);
  font-size: 16px;
  font-weight: 900;
  border-radius: 5px;
  cursor: pointer;

  &:disabled {
    background: #b9adff;
    border-color: #c5c5c5;
  }
`;

interface buttonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

const Button: React.FC<buttonProps> = ({ children, ...props }) => {
  return <ButtonStyled {...props}>{children}</ButtonStyled>;
};

export default Button;
